import { GENERATE_CLIENT_TOKEN, TRANSACTION_SALE, BRAINTREE_RESPONSE, TRANSACTION_SUBMIT, TRANSACTION_VOID, SET_FETCH_RECENT_PAYMENT_METHOD_LOADER, RESET_BRAINTREE_REDUCER, } from '../../constants';
export function generateClientToken(payload, successCallback = null, errorCallback = null) {
    return {
        type: GENERATE_CLIENT_TOKEN,
        payload,
        successCallback,
        errorCallback,
    };
}
export function transactionSale(payload, successCallback = null, errorCallback = null) {
    return {
        type: TRANSACTION_SALE,
        payload,
        successCallback,
        errorCallback,
    };
}
export function braintreeResponse(payload) {
    return {
        type: BRAINTREE_RESPONSE,
        payload,
    };
}
export function transactionSubmit(payload, successCallback = null, errorCallback = null) {
    return {
        type: TRANSACTION_SUBMIT,
        payload,
        successCallback,
        errorCallback,
    };
}
export function transactionVoid(payload, successCallback = null, errorCallback = null) {
    return {
        type: TRANSACTION_VOID,
        payload,
        successCallback,
        errorCallback,
    };
}
export function setLoaderForFetchRecentPaymentMethod(payload) {
    return {
        type: SET_FETCH_RECENT_PAYMENT_METHOD_LOADER,
        payload,
    };
}
export const resetBraintreeReducer = () => ({
    type: RESET_BRAINTREE_REDUCER,
});
